/*************  TILLFÄLLIGT BYTA UT ALLA LÄNKAR TILL BOKA.KLOSTERHOTEL.SE /*************/


// Hämta alla a-taggar på sidan
//const links = document.querySelectorAll('a');

// Loopa igenom varje länk
//links.forEach(link => {
//    // Kontrollera om href innehåller "boka.klosterhotel.se"
//    if (link.href.includes('boka.klosterhotel.se')) {
//        // Byt ut href till den nya länken
//        link.href = 'https://www.klosterhotel.se/weekend/onlinebokning-tillfälligt-stängd/';
//    }
//});

/*************  INIT TOOLTIP /*************/
import { Tooltip } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipTriggerList.forEach((el) => {
    new Tooltip(el);
  });
});

/*************  TOP-MENU SET ACTIVE /*************/

$(function () {
  if (location.pathname != "/") {
    // first set active to all that match url
    $(".main-navbar .navbar-nav a[href='" + location.href + "']").each(function () {
      var url = $(this).attr("href");
      if ($(this).hasClass("dropdown-toggle")) {
        $(this).parent().addClass('active');
      } else {
        $(this).addClass('active');
      }
    });
    // then set parent dropdown-toggle to active
    $(".main-navbar .active").each(function () {
      $(this).closest(".dropdown").addClass('active');
    });
  }
});


/*************  TOP-MENU SHOW SEARCH  /*************/



$(function () {
  $(".main-navbar .search-trigger").click(function (e) {
    $(".main-navbar .search-form-wrapper").toggle();
    return false;
  });
});


/*************  TOP-MENU SET NOW-STICKY /*************/

$(function () {
  var navbar = $(".main-navbar").first();
  var initialNavbarStartPos = navbar.position().top;
  var initialNavbarEndPos = initialNavbarStartPos + navbar.outerHeight(true);
  $(window).on('scroll', () => {
    var winPos = $(window).scrollTop();
    if (winPos > initialNavbarEndPos + 1) {
      if ($(".main-navbar").hasClass("now-sticky") == false) {
        $(".main-navbar").css("opacity", "0");
        //$(".main-navbar").hide();
        $(".main-navbar").removeClass("scrolled-back-to-top");
        $(".main-navbar").addClass("now-sticky");
        $(".main-navbar").fadeTo(250, 1);
      }
    } else if ($(window).scrollTop() < initialNavbarStartPos) {
      if ($(".main-navbar").hasClass("now-sticky") == true) {

        $(".main-navbar").removeClass("now-sticky");
        $(".main-navbar").addClass("scrolled-back-to-top");
      }
    }
  });
  $(window).trigger('scroll');
});

/*************  REPLACE ALL BACKVGROUND-IMAGES WHEN NO SUPPORT FOR WEBP /*************/

$("#button").click(function () {
  $('html, body').animate({
    scrollTop: $("#myDiv").offset().top
  }, 2000);
});


/*************  SKIP TO NEXT /*************/

$(function () {
  $(".skip-to-next").click(function () {
    document
      .getElementById("skip-to-next-anchor")
      .scrollIntoView({ behavior: "smooth" });
  });
});

/*************  SET HEIGHT IN MODULE TESTIMONAILS  /*************/


$(function () {

  if ($(".m-testimonials .carousel-item").length) {
    var refreshIntervalId = setInterval(function () {
      var minHeight = 0;
      $(".m-testimonials .carousel-item").each(function () {

        if ($(this).height() > minHeight) {
          minHeight = $(this).height();
        }
      });
      minHeight = minHeight;
      $(".m-testimonials .carousel-item").each(function () {
        $(this).css("min-height", minHeight)
      });
    }, 1000);
  }

});

/*
-------- SET VIDEOSECTION TO HORIZONTAL OR VERTICAL WINDOW
*/

$(function () {

  $(window).on("resize", function () {

    $(".m-videosection").each(function () {

      var width = $(this).width();
      var height = $(this).height();

      if ((height * 16 / 9) < width) {
        $(this).addClass("h-browser");
        $(this).removeClass("v-browser");
      } else {
        $(this).addClass("v-browser");
        $(this).removeClass("h-browser");

      }
    });
  }).resize();
});

/*************  ADD SAFARI-MAC /*************/

(function ($) {
  // console.log(navigator.userAgent);
  /* Adjustments for Safari on Mac */
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Mac') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    // console.log('Safari on Mac detected, applying class...');
    $('html').addClass('safari-mac'); // provide a class for the safari-mac specific css to filter with
  }
})(jQuery);

/*************  EXPANDABLE /*************/

$(function () {

  $(".m-expandable .toggle-title").click(function () {
    $parent = $(this).closest(".m-expandable");
    $content = $parent.find(".toggle-content");
    $parent.toggleClass("active");
    $content.slideToggle(500, function () { });
    return false;
  });
});





/*************  OPEN EXTERNAL LINKS IN NEW WINDOW /*************/


$(function () {
  $('a').each(function () {
    var openLinkInNewWindow2 = openLinkInNewWindow($(this));
    if (openLinkInNewWindow2) {
      $(this).prop('target', '_blank');
    }

  });
});


function openLinkInNewWindow(element) {
  var href = element.attr("href");
  if ((/^\//.test(href))) {
    return false;
  }
  if (!href || href.startsWith('javascript:')) {
    return false;
  }
  if (/^https:\/\/klosterhotel\./.test(href)) {
    return false;
  }
  if (/^http:\/\/klosterhotel\./.test(href)) {
    return false;
  }
  if (/^https:\/\/kh.style4/.test(href)) {
    return false;
  }
  if (/^https:\/\/www.klosterhotel\./.test(href)) {
    return false;
  }
  if (/^https:\/\/klosterhotel\./.test(href)) {
    return false;
  }
  if (/^https:\/\/online.bookvisit\.com/.test(href)) {
    return false;
  }
  if (/^https:\/\/boka.klosterhotel\.se/.test(href)) {
    return false;
  }
  if (/\.pdf$/.test(href)) {
    return false;
  }
  if (/\.doc$/.test(href)) {
    return false;
  }
  if (/\.xls$/.test(href)) {
    return false;
  }
  if (/\.ppt$/.test(href)) {
    return false;
  }
  if (/^mailto:/.test(href)) {
    return false;
  }
  if (/^tel:/.test(href)) {
    return false;
  }
  if (/^#/.test(href)) {
    return false;
  }

  return true;
}

/*************  FUNCTION SHOW POPUP  /*************/


(function () {

  var distance = 2000;               // Scroll distance in pixel.
  var expireKey = 'newsletter';      // Name of the localStorage timestamp.

  function maybeShowPopup() {
    // Check if the user scrolled far enough.
    if ($(window).scrollTop() < distance) {
      return;
    }

    // Remove the custom scroll event, to avoid displaying the popup multiple times.
    $(window).off('.popup_' + expireKey);

    // Check, if the popup was displayed already today.
    if (window.localStorage) {
      var nextPopup = localStorage.getItem(expireKey);

      if (nextPopup > new Date()) {
        return;
      }

      var expires = new Date();
      expires = expires.setHours(expires.getHours() + 8760);
      localStorage.setItem(expireKey, expires);
    }

    $("#newsletter-modal").modal('show');

  }

  $(window).on('scroll.popup_' + expireKey, maybeShowPopup);
})()

$(function () {
  $('#newsletter-modal').on('shown.bs.modal', function () {
    $('#newsletter-modal iframe').each(function () {
      $(this).renameAttr('data-src', 'src');
    });
  })
});


/*************  FUNCTIONS  /*************/

jQuery.fn.extend({
  renameAttr: function (name, newName, removeData) {
    var val;
    return this.each(function () {
      val = jQuery.attr(this, name);
      jQuery.attr(this, newName, val);
      jQuery.removeAttr(this, name);
      // remove original data
      if (removeData !== false) {
        jQuery.removeData(this, name.replace('data-', ''));
      }
    });
  }
});



/*
-------- BG-VIDEO-CONTAINER (FOR COLUMN)
*/

$(function () {

  $(window).on("resize", function () {
    $(".m-col>.bg-video-container").each(function () {
      var parent = $(this).parent();
      var parentContainer = parent.parent().parent();
      parentPaddingLeft = parseInt(parent.css("padding-left"));
      parentPaddingright = parseInt(parent.css("padding-right"));
      totalPadding = parentPaddingLeft + parentPaddingright;

      $(this).css("margin-left", -parentPaddingLeft);
      $(this).css("width", "calc(100% + " + totalPadding + "px)");

      var iframe = $(this).find("iframe");

      if ($(this).width() > $(window).width() * 0.9) { // if only one column width (mobile-mode)
        $(this).css("padding-bottom", "calc(56.25% + " + parentPaddingLeft + "px)");
        $(this).addClass("mobile-mode");
      } else {
        $(this).removeClass("mobile-mode");
        var height = $(this).height();
        iframe.css("width", "calc(" + height + "px * 16 / 9)");
      }

      iframe.show();

    });
  }).resize();
});

/* bestämmer om tillbaka-länkar ska sparas */
document.addEventListener('DOMContentLoaded', () => {
  const activeRoots = window.backlinkActiveRoots || [];            /* ❷ */

  document.body.addEventListener('click', e => {
    const link = e.target.closest('a');
    if (!link || !link.href) return;

    const dest = new URL(link.href, location.href);
    if (dest.origin !== location.origin) return;

    const inNavbar = link.closest('.main-navbar') !== null || link.dataset.nav === '1';
    if (inNavbar) {
      sessionStorage.removeItem('back_prevUrl');
      sessionStorage.removeItem('back_prevTitle');
      return;
    }

    /* Spara bara om den sida man lämnar TILLHÖR en aktiv gren */
    const curSec = location.pathname.split('/')[1] || '';
    if (!activeRoots.includes(curSec)) return;                     /* ❷ */

    sessionStorage.setItem('back_prevUrl', location.href);
    const m = document.querySelector('meta[name="entry-title"]');
    sessionStorage.setItem('back_prevTitle', m ? m.content : document.title);
  });
});

/* Vegas slideshow on sections */

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("script.vegas-config").forEach(function (el) {
    try {
      const slides = JSON.parse(el.textContent);
      const target = el.dataset.target;

      if (slides.length > 0 && document.querySelector(target)) {
        document.querySelector(target).classList.add("vegas-initialized");
        $(target).vegas({
          slides: slides,
          delay: 5000,
          transition: "fade",
          timer: false,
          transitionDuration: 1000,
          animation: 'kenburns'
        });
      }
    } catch (err) {
      console.warn("Kunde inte initiera Vegas:", err);
    }
  });
});

